import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { usersApi } from "@/lib/users.api";
import { queryKeys } from "@/lib/query-keys";

export function useDeleteUserMutation() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: number) => usersApi.remove(id).then((r) => r.data),
    onSuccess: () => {
      toast.success("Utilisateur supprimé.");
      queryClient.invalidateQueries({ queryKey: queryKeys.users() });
    },
  });
}
